import { FunctionComponent } from 'react';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutSectionListSimple: FunctionComponent<Props> = ({ headline, list }) => {
    return (
        <StyledComponent className="public-layout-section-list-simple">
            <LayoutContainer size={Sizes.XMedium}>
                <div className="content-container">
                    <div className="headline">
                        <h2 dangerouslySetInnerHTML={{ __html: headline }} />
                    </div>
                    <div className="list-simple">
                        {list && list.map((listItem) => (
                            <div
                                className="list-simple__item"
                                key={listItem.title}
                            >
                                <div className="bg" />
                                <div className="list-simple__item-title">{listItem.title}</div>
                                <div
                                    className="list-simple__item-subtitle"
                                    dangerouslySetInnerHTML={{ __html: listItem.subtitle || listItem.content }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicLayoutSectionListSimple;
